import Vue from 'vue'
import Vuex from 'vuex'
import {setStore, getStore} from '@/util/store'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: getStore({name: 'user'}),
    token: getStore({name: 'token'}),
    pwd: getStore({name: 'pwd', type: 'session'}),
  },
  getters: {},
  mutations: {
    setUser(state, user) {
      state.user = user;
      setStore({name: 'user', content: user});
    },
    setToken(state, token) {
      state.token = token;
      setStore({name: 'token', content: token});
    },
    logOut(state) {
      state.user = null;
      setStore({name: 'user', content: null});
    },
    setPwd(state, pwd) {
      state.pwd = pwd;
      setStore({name: 'pwd', type: 'session', content: pwd});
    },
  },
  actions: {}
})
export default store
